import React from 'react';
interface BannerSpec {
  width: number;
  height: number;
  ratio: string;
}
interface OffersBannerRowProps {
  columns: number;
  bannerSpec: BannerSpec;
  count: number;
  className?: string;
}
export function OffersBannerRow({
  columns,
  bannerSpec,
  count,
  className = ''
}: OffersBannerRowProps) {
  const banners = Array.from({
    length: count
  }, (_, i) => i + 1);
  const aspectRatio = bannerSpec.height / bannerSpec.width * 100;
  return <div className={`container mx-auto px-4 ${className}`} data-id="element-4512" data-mp="3t6vec1oaviek">
      <div className={`hidden md:grid gap-3 md:gap-4`} style={{
      gridTemplateColumns: `repeat(${columns}, 1fr)`
    }} data-id="element-4513" data-mp="1zsq9j3rds8k">
        {banners.map(num => <a key={num} href="#" className="bg-gray-300 rounded-xl overflow-hidden relative group transition-all" data-id="element-4514" data-mp="3o67hv0hay9cy">
            <div className="w-full" style={{
          paddingTop: `${aspectRatio}%`
        }} data-id="element-4515" data-mp="1mdt0q3ml18xl"></div>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-4516" data-mp="3lt1t6fnum2ck">
              <div className="text-center text-gray-700" data-id="element-4517" data-mp="3gv0a3uqfa313">
                <div className="text-2xl font-bold mb-2" data-id="element-4518" data-mp="3vkfwyzmu1obi">Banner {num}</div>
                <div className="text-sm" data-id="element-4519" data-mp="3vmim7hg5vdf6">Click to explore</div>
              </div>
            </div>
            <div className="absolute bottom-2 left-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded" data-id="element-4520" data-mp="3qnyypclx5tkp">
              {bannerSpec.width}×{bannerSpec.height} — {bannerSpec.ratio}
            </div>
          </a>)}
      </div>
      <div className="md:hidden -mx-4" data-id="element-4521" data-mp="3bwyph5dclvni">
        <div className="overflow-x-auto scrollbar-hide px-4" data-id="element-4522" data-mp="3by1hjgmeq450">
          <div className="flex gap-3 pb-2" data-id="element-4523" data-mp="37u22z3kotfea">
            {banners.map(num => <a key={num} href="#" className="bg-gray-300 rounded-xl overflow-hidden relative flex-shrink-0" style={{
            width: columns > 4 ? '150px' : '280px'
          }} data-id="element-4524" data-mp="r5y8ewyula5t">
                <div className="w-full" style={{
              paddingTop: `${aspectRatio}%`
            }} data-id="element-4525" data-mp="3kyh5s34pcynp"></div>
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-4526" data-mp="3pvfx6dwzeri7">
                  <div className="text-center text-gray-700" data-id="element-4527" data-mp="3tym3flk3gioo">
                    <div className="text-lg font-bold mb-1" data-id="element-4528" data-mp="2x9o5juh1s4na">Banner {num}</div>
                    <div className="text-xs" data-id="element-4529" data-mp="327pz59c3nmd0">Tap to view</div>
                  </div>
                </div>
                <div className="absolute bottom-2 left-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded" data-id="element-4530" data-mp="369t9tvqy2mx8">
                  {bannerSpec.ratio}
                </div>
              </a>)}
          </div>
        </div>
      </div>
      <style jsx data-id="element-4531" data-mp="2ehvl4og1nrr6">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
}